import { API_TYPES } from "@src/appV2/api/constants";
import { z } from "zod";

const ShiftBoostStatusSchema = z.enum(["AVAILABLE", "EXPIRED", "APPLIED", "PAID", "DELETED"]);

const ShiftBoostStatusFilterSchema = z.array(ShiftBoostStatusSchema).optional();

export const GetShiftBoostsQuerySchema = z.object({
  filter: z.object({ status: ShiftBoostStatusFilterSchema }).optional(),
});

const ShiftBoostAttributesSchema = z.object({
  amount: z.number(),
  expiresAt: z.string().datetime(),
  status: ShiftBoostStatusSchema,
});

const ShiftBoostShiftRelationshipSchema = z.object({
  data: z.object({ type: z.literal(API_TYPES.shift), id: z.string() }),
});

const ShiftBoostWorkerRelationshipSchema = z.object({
  data: z.object({ type: z.literal(API_TYPES.worker), id: z.string() }),
});

const ShiftBoostRelationshipsSchema = z.object({
  shift: ShiftBoostShiftRelationshipSchema.optional(),
  worker: ShiftBoostWorkerRelationshipSchema,
});

const ShiftBoostDataSchema = z.object({
  type: z.literal(API_TYPES.shiftBoost),
  id: z.string(),
  attributes: ShiftBoostAttributesSchema,
  relationships: ShiftBoostRelationshipsSchema,
});

export const GetShiftBoostsResponseSchema = z.object({
  data: z.array(ShiftBoostDataSchema),
});

export type GetShiftBoostsResponse = z.infer<typeof GetShiftBoostsResponseSchema>;
export type ShiftBoost = z.infer<typeof ShiftBoostDataSchema>;
export type ShiftBoostStatus = z.infer<typeof ShiftBoostStatusSchema>;
